export default "__VITE_ASSET__00g0DQ8L__"